export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11934.d8e04679.jpg";